export const DEFAULT_FEATURES = [
  {
    id: 1,
    title: "Smart Scheduling",
    description: "Let clients book, reschedule, and receive reminders.",
    features: [
      "Easily manage appointments with a simple, user-friendly calendar.",
      "Send automated reminders to reduce no-shows and keep clients on track.",
      "Allow flexible rescheduling so clients stay consistent with their plans.",
    ],
  },
  {
    id: 2,
    title: "Automated Billing",
    description: "Get paid on time with effortless, secure billing tools.",
    features: [
      "Streamline payments with secure, automatic billing options.",
      "Save time with recurring invoices and subscription management.",
      "Track transactions and client payments in one convenient dashboard.",
    ],
  },
  {
    id: 3,
    title: "Client Progress Tracking",
    description: "Keep clients motivated with clear, visualized progress.",
    features: [
      "Monitor nutrition, workouts, and lifestyle habits in real time.",
      "Provide visual progress reports to keep clients motivated.",
      "Adjust plans quickly based on measurable results and feedback.",
      "Automated email & SMS reminders reduce no shows",
    ],
  },
  {
    id: 4,
    title: "HIPAA-Compliant Messaging",
    description:
      "Build trust with secure, private communication right in the app.",
    features: [
      "Communicate securely with clients while protecting sensitive health data.",
      "Share personalized recommendations, documents, and feedback safely.",
      "Build trust with encrypted, professional grade messaging.",
    ],
  },
];

export const FEATURES_CONFIG = {
  title: "Everything You Need to Run Your Nutrition Practice All in One Place",
  subtitle: "Features Made Simple",
  description:
    "Fitify takes care of the busywork so you can focus on what matters most your clients.",
};
